import React from 'react';
import { connect } from 'react-redux';
import { openOrderCancelDialog, openOrderJournalDetailDialog, openOrderModifyDialog } from '@/actions/app';
import { orderActions } from '@/actions/trading';
import { SERVICES_RESP } from '@/configurations';
import { REFRESH_DATA } from '@/constants/app';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import DataTable from '../DataTable/DataTable';
import { checkSessionAction } from '@/actions/auth'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'

let IntervalRef;
let IntervalCheckSessionRef;

class OrderBook extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      data: null,
      status:'',
      instrumentID:'',
      columnDefs: [
        {
          headerName: props.language.common_actions,
          colId: 'common_actions',
          headerClass: 'table-header text-center',
          cellClass: 'table-cell',
          dataType: dataType.EDIT_CANCEL,
          cellRendererParams: {
            onEditOrder: this.handleEditOrder,
            onCancelOrder: this.handleCancelOrder,
          },
          sortable: false,
          minWidth: 60
        },
        {
          headerName: props.language.common_order_id,
          colId: 'common_order_id',
          field: 'orderGroupID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          cellRendererParams: {
            action: this.handleViewOrderDetail
          },
          minWidth: 80

        },
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'instrumentID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          cellRendererParams: {
            // market: 'marketID',
            instrument: 'instrumentID'
          },
          minWidth: 80
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'instrumentName',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.STOCK_NAME,
          cellRendererParams: {
            stockName: 'instrumentName',
            chineseStockName: 'instrumentChineseName'
          },
        },
        {
          headerName: props.language.common_market,
          colId: 'common_market',
          field: 'marketID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth: 60
        },
        {
          headerName: props.language.common_ccy,
          colId: 'common_ccy',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth: 60

        },
        {
          headerName: props.language.common_buy_sell,
          colId: 'common_buy_sell',
          field: 'bs',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 60
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          flex: 1,
          minWidth: 50

        },
        {
          headerName: props.language.common_quantity,
          colId: 'common_quantity',
          field: 'qty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          minWidth: 50
        },
        {
          headerName: props.language.common_exe_qty,
          colId: 'common_exe_qty',
          field: 'filledQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          minWidth: 80
        },
        {
          headerName: props.language.common_outstanding_quantity,
          colId: 'common_outstanding_quantity',
          field: 'osQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          minWidth: 70
        },
        {
          headerName: props.language.common_avg_price,
          colId: 'common_avg_price',
          field: 'avgPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.AVG_PRICE,
          minWidth: 80


        },
        {
          headerName: props.language.common_status,
          colId: 'common_status',
          field: 'status',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 80,
        },
        {
          headerName: props.language.common_order_type,
          colId: 'common_order_type',
          field: 'orderType',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.ORDER_CELL_RENDER,
          minWidth: 140,
          flex: 1

        },
        {
          headerName: props.language.common_trigger_price,
          colId: 'common_trigger_price',
          field: 'stopPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          minWidth: 70,
        },
        {
          headerName: props.language.common_net_amount,
          colId: 'common_net_amount',
          field: 'netAmt',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CASH,
          minWidth: 100,

        },
        {
          headerName: props.language.common_good_till_date,
          colId: 'common_good_till_date',
          field: 'goodTillDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE,
          flex: 1

        },
        {
          headerName: props.language.common_last_update,
          colId: 'common_last_update',
          field: 'modifiedTime',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.LONG_DATE,
          minWidth: 80
        },
        {
          headerName: props.language.common_order_time,
          colId: 'common_order_time',
          field: 'inputTime',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.LONG_DATE,
          minWidth: 130

        }
      ]
    }
  }
  render() {
    const { data, columnDefs } = this.state;
    return (
      <div className="order-book-container" style={{ flexGrow: 1 }}>
        <DataTable
          innerRef={e => this.tableRef = e}
          columnDefs={columnDefs}
          data={data}
          autoSizeColumns={true} />
      </div>
    )
  }

  handleEditOrder = (order) => {
    openOrderModifyDialog(order);
  }

  handleCancelOrder = (order) => {
    openOrderCancelDialog(order);
  }

  handleViewOrderDetail = (order) => {
    openOrderJournalDetailDialog(order, null, false, true, false);
  }

  getData(status = '', startDate = '', endDate = '',instrumentID = '',refreshSession = false) {
    const { currentTradingAccount, token, language } = this.props
    this.setState({
      status:status,
      instrumentID:instrumentID
    })
    if (currentTradingAccount.clientID && token) {
      if (this.tableRef && refreshSession) {
        this.tableRef.toggleLoadingOverlay(true);
      }
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.STATUS]: status,
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.INSTRUMENT_ID]:instrumentID,
      }
      if(refreshSession === false){
        params[PARAMS.REFRESH_SESSION] = false
      }
      this.props.getOrderBook(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ data: res.result.orderInfoList });
            this.props.toggleRefreshTable(false)
          } else {
            this.setState({
              data: []
            })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.getData();
    }
    if (this.props.token && this.props.token !== prevProps.token) {
      this.getData();
    }
    if (this.props.language && this.props.language !== prevProps.language) {
      // this.getData();
    }
  }

  componentDidMount() {
    this.getData();
    let autoRefreshOrderEnquiry = iTradeEnv?.actions?.trading?.autoRefreshOrderEnquiry
    let autoCheckSession = iTradeEnv?.actions?.trading?.autoCheckSession
    IntervalCheckSessionRef = setInterval(() => {
      if(this.props.stopQutoRefresh === 'true'){
        clearInterval(IntervalCheckSessionRef)
      } else {
        this.props.checkSession('',res=>{}, error=>{
          if(SERVICES_RESP.SESSION_TIMEOUT.includes(error.result.errorCode))
          clearInterval(IntervalCheckSessionRef)
        })
      }
    }, autoCheckSession);
    IntervalRef = setInterval(() => {
      if(this.props.stopQutoRefresh === 'true'){
        clearInterval(IntervalRef)
      } else {
        this.getData(this.state.status,'','',this.state.instrumentID,false);
      }
    }, autoRefreshOrderEnquiry);
  }

  componentWillUnmount() {
    IntervalRef && clearInterval(IntervalRef)
  }
}

OrderBook.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    token: state.auth.token,
    stopQutoRefresh: state.trade.stopQutoRefresh,
  }),
  dispatch => ({
    getOrderBook: (p, c) => dispatch(orderActions.getOrderBookAction(p, c)),
    checkSession: (p, c, b) => dispatch(checkSessionAction(p, c, b)),
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.ORDER_TABLE,
      value: p
    })
  })
)(OrderBook)
